/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 问卷按钮组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-01-09 14:15:32
 */
import React from 'react'
import './index.scss'

import desktopLib from '../../../../../utils/desktopLib'
import { FileTextOutlined } from '@ant-design/icons'

interface SurveyButtonProps {
  surveyUrl?: string
  onClick?: () => void
}

const SurveyButton: React.FC<SurveyButtonProps> = ({
  surveyUrl = 'https://alidocs.dingtalk.com/notable/share/form/v013BMqYybKYzKb6qwZ_hERWDMS_WyPvuh8',
  onClick
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
    // 打开问卷链接：客户端使用 openContact，Web端使用 window.open
    if (desktopLib.isDesktop) {
      desktopLib.openContact(surveyUrl)
    } else {
      window.open(surveyUrl, '_blank')
    }
  }

  return (
    <button className="survey-button" onClick={handleClick}>
      {/* 蓝色图标 - 剪贴板 */}
      <FileTextOutlined />
      {/* 文字 */}
      <span className="survey-text">体验官反馈</span>
      {/* 红色通知点 */}
      <span className="notification-dot"></span>
    </button>
  )
}

export default SurveyButton
